module.exports = __webpack_public_path__ + "media/scholarship_winners/andrew-sw-b72ecd25.png";